export const STATUSES = [
  { key: "active", label: "Active", color: "#3b82f6" },
  { key: "on_hold", label: "On hold", color: "#f59e0b" },
  { key: "done", label: "Done", color: "#10b981" },
];

export const statusOf = (k) => STATUSES.find((s) => s.key === k) || STATUSES[0];

export const StatusPicker = ({ value, onChange, testPrefix = "status-pick" }) => (
  <div className="inline-flex rounded-full border p-1">
    {STATUSES.map((s) => (
      <button key={s.key} type="button" onClick={() => onChange(s.key)} data-testid={`${testPrefix}-${s.key}`}
        className={`rounded-full px-4 py-1.5 text-xs font-semibold transition-colors ${value === s.key ? "" : "text-muted-foreground hover:text-foreground"}`}
        style={value === s.key ? { background: `${s.color}22`, color: s.color } : {}}>
        {s.label}
      </button>
    ))}
  </div>
);
